export const extractServerMessage = (data) => {
    if (!data) return null;
    if (typeof data === "string") return data;

    // Common DRF-style keys
    if (typeof data.detail === "string") return data.detail;
    if (typeof data.message === "string") return data.message;
    if (typeof data.error === "string") return data.error;

    // Some endpoints wrap details
    const results = data.results;
    if (results) {
        if (typeof results.detail === "string") return results.detail;
        if (Array.isArray(results.detail) && typeof results.detail[0] === "string") return results.detail[0];
        if (typeof results.message === "string") return results.message;
    }

    // Validation / field errors: pick first string-like value
    if (typeof data === "object") {
        for (const v of Object.values(data)) {
            if (typeof v === "string") return v;
            if (Array.isArray(v) && typeof v[0] === "string") return v[0];
        }
    }

    return null;
};

